import { render, staticRenderFns } from "./DfSummaryTable.vue?vue&type=template&id=a74f44fa"
import script from "./DfSummaryTable.vue?vue&type=script&lang=js"
export * from "./DfSummaryTable.vue?vue&type=script&lang=js"
import style0 from "./DfSummaryTable.vue?vue&type=style&index=0&id=a74f44fa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports